import { c as _c } from "react/compiler-runtime";
import { Modal } from '@common/components';
import { cn } from '@core/utils';
import type { ResponsiveDialogConfig } from '@/stores/DrawerStore';
interface DonationModalProps {
  opened: boolean;
  onClose?: () => void;
  header?: ResponsiveDialogConfig['modalHeader'];
  children: React.ReactNode;
  className?: string;
}

/**
 * 고향사랑기부에서 사용하는 모달\
 * 모든 뷰포트에서 모달을 사용하는 특수한 경우가 아니라면\
 * 반응형에 따라 적합한 컴포넌트를 렌더링 해주는 ResponsiveDialog를 대신 사용
 */
export const DonationModal = t0 => {
  const $ = _c(14);
  const {
    opened,
    onClose,
    header,
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== header) {
    t1 = () => {
      if (typeof header === "string") {
        return <Header title={header} />;
      }
      if (header && typeof header === "object" && "title" in header) {
        return <Header title={header.title} description={header.description} />;
      }
      return header;
    };
    $[0] = header;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const renderHeader = t1;
  let t2;
  if ($[2] !== renderHeader) {
    t2 = renderHeader();
    $[2] = renderHeader;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== className) {
    t3 = cn("!max-h-[90%] !min-h-0 w-full !min-w-0 max-w-[480px] !px-0 text-start", className);
    $[4] = className;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== children) {
    t4 = <div><div className="px-32">{children}</div></div>;
    $[6] = children;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== onClose || $[9] !== opened || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <Modal opened={opened} onClose={onClose} header={t2} headerClassName="px-32 mb-24" asChild={true} className={t3} closeButton={true}>{t4}</Modal>;
    $[8] = onClose;
    $[9] = opened;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
interface HeaderProps {
  title: string;
  description?: string;
}
const Header = t0 => {
  const $ = _c(7);
  const {
    title,
    description
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h2 className="whitespace-pre-line typo-inherit">{title}</h2>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = description ? <p className="mt-12 whitespace-pre-line font-400 text-Gray-700 typo-body3">{description}</p> : null;
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div>{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};